$(document).ready(function() {

  // Show password form when "change password" clicked
  $(document).on('click', '.user-settings-container .change-password-btn--js', function() {
    const parent = $(this).closest('.user-settings-container');
    const changePassForm = parent.find('.change-password-form');
    changePassForm.removeClass('d-none');
    $(this).addClass('d-none');
  })
  // Hide password form when "confirm change" clicked
  $(document).on('click', '.user-settings-container .confirm-change-btn', function() {
    const parent = $(this).closest('.user-settings-container');
    const changePassForm = parent.find('.change-password-form');
    changePassForm.addClass('d-none');
    parent.find('.change-password-btn--js').removeClass('d-none');
  })
  // Quick add brand
  $(document).on('change', '.user-settings-container .quick-add-brand', function() {
    $.post('/user_brand_favorites', {
      brand_id: $(this).val(),
    }, function(data) { // Reload page after submit
      const url = new URL(window.location.href);
      url.searchParams.set('selected_tab', 'lists');
      window.location.href = url.toString();
    })
  })
})